import { useState } from "react";
import { resolveHfdXsKeycodeLabel } from "../../../utils/keyCodeMapperHfd";
import { Dk108KnobInteractiveIcon } from "../../Keyboard/Dk108KnobInteractiveIcon";
import {
  HFD_DK108_KNOB_ACTIONS,
  type HfdDk108KnobActionId,
} from "@eweadn-qiankun/shared-utils";

type Dk108KnobRemapPreviewProps = {
  bindings: Record<HfdDk108KnobActionId, number>;
};

function resolveBindingLabel(keycode: number): string {
  return resolveHfdXsKeycodeLabel(keycode) || `键码 ${keycode}`;
}

function PreviewTooltip({
  title,
  value,
  placement,
  visible,
}: {
  title: string;
  value: string;
  placement: "left" | "right-top" | "right-bottom";
  visible: boolean;
}) {
  return (
    <div
      className={[
        "dk108-knob-demo__tooltip",
        `dk108-knob-demo__tooltip--${placement}`,
        visible ? "is-visible" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      aria-hidden={!visible}
    >
      <span className="dk108-knob-demo__tooltip-title">{title}</span>
      <span className="dk108-knob-demo__tooltip-value">{value}</span>
    </div>
  );
}

/** 配置社区改键预览：DK108 旋钮三向绑定只读展示 */
export default function Dk108KnobRemapPreview({
  bindings,
}: Dk108KnobRemapPreviewProps) {
  const [hoveredAction, setHoveredAction] =
    useState<HfdDk108KnobActionId | null>(null);

  const pressAction = HFD_DK108_KNOB_ACTIONS.find(
    (item) => item.id === "press"
  );
  const clockwiseAction = HFD_DK108_KNOB_ACTIONS.find(
    (item) => item.id === "clockwise"
  );
  const counterClockwiseAction = HFD_DK108_KNOB_ACTIONS.find(
    (item) => item.id === "counterClockwise"
  );

  return (
    <div className="dk108-knob-demo">
      <div className="dk108-knob-demo__canvas">
        <div className="dk108-knob-demo__icon-wrap">
          <Dk108KnobInteractiveIcon
            readOnly
            hoveredAction={hoveredAction}
            onActionHover={setHoveredAction}
          />

          {pressAction ? (
            <PreviewTooltip
              title={pressAction.label}
              value={resolveBindingLabel(bindings.press)}
              placement="left"
              visible={hoveredAction === "press"}
            />
          ) : null}
          {clockwiseAction ? (
            <PreviewTooltip
              title={clockwiseAction.label}
              value={resolveBindingLabel(bindings.clockwise)}
              placement="right-top"
              visible={hoveredAction === "clockwise"}
            />
          ) : null}
          {counterClockwiseAction ? (
            <PreviewTooltip
              title={counterClockwiseAction.label}
              value={resolveBindingLabel(bindings.counterClockwise)}
              placement="right-bottom"
              visible={hoveredAction === "counterClockwise"}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
